<jsg-single-row-panel>
  <div first>
    <div>Civil matter type</div>
    <div>{{ civilMatterType }}</div>
  </div>
  <div second>
    <div>Judicial center</div>
    <div>
      {{ jurisdiction }}
    </div>
  </div>
</jsg-single-row-panel>
